var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGreencheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7016 0.649574C18.4975 1.43307 18.4975 2.71648 17.7016 3.49998L9.25896 11.812C8.48051 12.5784 7.23113 12.5784 6.45268 11.812L0.596861 6.0468C-0.198953 5.2633 -0.198954 3.97989 0.596861 3.19639L0.672812 3.12162C1.45126 2.35522 2.70064 2.35522 3.47909 3.12162L6.45268 6.04917C7.23113 6.81557 8.48051 6.81557 9.25896 6.04917L14.8194 0.574798C15.5979 -0.191599 16.8472 -0.1916 17.6257 0.574798L17.7016 0.649574Z",
    fill: "#55C595"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGreencheck);
export default __webpack_public_path__ + "static/media/icon_greencheck.ba715bf2648f035f987de76f9229ce6a.svg";
export { ForwardRef as ReactComponent };